<template>
  <!-- 返现历史记录 -->
  <el-dialog :title="title" :visible="visible" :show-close="false">
    <el-table
      ref="table"
      :data="list"
      stripe
      border
      :summary-method="getSummaries"
      show-summary
      style="width:100%">
      <el-table-column
        prop="school_name"
        label="驾校名称"
        width="120">
      </el-table-column>
      <el-table-column
        prop="coach_name"
        label="教练"
        width="80">
      </el-table-column>
      <el-table-column
        prop="return_time"
        label="返现时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="return_money"
        label="返现金额"
        width="80">
      </el-table-column>
      <el-table-column
        prop="return_oper_name"
        label="返现操作员"
        width="100">
      </el-table-column>
      <el-table-column
        prop="bill_no"
        label="单据编号"
        width="120">
      </el-table-column>
      <el-table-column
        prop="car_alias"
        label="车辆编号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="licnum"
        label="车牌号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="开始时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="结束时间"
        width="160">
      </el-table-column>
      <el-table-column
        prop="use_time"
        label="时长"
        width="80">
      </el-table-column>
      <el-table-column
        prop="fee"
        label="应收金额"
        width="80">
      </el-table-column>
      <el-table-column
        prop="fee_discount"
        label="优惠"
        width="70">
      </el-table-column>
      <el-table-column
        prop="pay_total"
        label="实收合计"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pay_cash"
        label="现金"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pay_alipay"
        label="支付宝"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pay_wechat"
        label="微信支付"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pay_pos"
        label="银行卡"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pay_balance"
        label="充值卡"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pay_coupon"
        label="代金券"
        width="80">
      </el-table-column>
      <el-table-column
        prop="pay_virtual"
        label="挂账"
        width="80"
        v-if="user.pay_virtual == '1'">
      </el-table-column>
      <el-table-column
        prop="pay_advance"
        label="预收"
        width="80"
        v-if="user.pay_advance == '1'">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="150">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageChange"
      :current-page="currentPage"
      :page-sizes="[15, 50, 100, 500]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <div slot="footer" class="dialog-footer">
      <el-button type="success" @click="excel" :loading="exporting">导出到excel</el-button>
      <el-button @click="close">关闭窗口</el-button>
    </div>
  </el-dialog>
</template>

<script>
import qs from 'qs'
export default {
  props: {
    coachId: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      default: '返现历史记录'
    }
  },
  data () {
    return {
      list: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      total: 0,
      exporting: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.fetchList()
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  methods: {
    fetchList () {
      let ps = { coach_id: this.coachId }
      if (this.pageSize > 0) {
        ps.start = (this.currentPage - 1) * this.pageSize
        ps.limit = this.pageSize
      }
      this.loading = true
      this.$http.get('/dbapi/return_history', {
        params: ps
      }).then(response => {
        if (response.data.success) {
          this.list = response.data.list
          this.total = response.data.total
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    pageChange (val) {
      this.currentPage = val
      this.fetchList()
    },
    pageSizeChange (val) {
      this.pageSize = val
      this.fetchList()
    },
    excel () {
      this.exporting = true
      this.$http.get('/dbapi/excel/return_history', {
        params: {
          coach_id: this.coachId
        }
      }).then(response => {
        this.exporting = false
        if (response.data.success) {
          this.$alert('导出成功,点击下载文件', '导出成功', {
            confirmButtonText: '下载文件',
            callback: action => {
              window.open(response.data.url)
            }
          })
        } else {
          this.$message({ type: 'error', message: '导出失败,' + response.data.message })
        }
      })
    },
    close () {
      this.$emit('close')
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.status === '作废' || row.status === '退款') {
        return 'row-red'
      } else {
        return ''
      }
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'use_time') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] += ' 分钟'
        } else if (column.property === 'fee' || column.property === 'fee_discount' || (column.property && column.property.indexOf('pay') === 0)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'return_money') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else if (column.property === 'coach_name') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/return/HistoryDialog.vue